/**
 * Auth session key for business bootstrap — NEVER use getUserInfo()/payload userInfo.
 * That is catalog metadata ({username,email}), not the login session, and caused
 * first-login empty UI (unlock without loadBusinessData).
 *
 * Single priority chain for login identity (use everywhere):
 *   business.id → auth_user_id → user.id → user.id (top-level)
 */

import { readStoredSessionUser } from '../../services/offlineAuthSession';
import { normalizeBusinessStorageId } from '../../utils/sharedCore';

/**
 * Canonical storage business id from a login/session user object.
 * @param {object|null|undefined} user
 * @returns {string}
 */
export function resolveSessionKeyFromUser(user) {
  if (!user || typeof user !== 'object') return '';
  const raw =
    (user.type === 'business' && user.business?.id ? user.business.id : null) ||
    user.business?.auth_user_id ||
    user.user?.id ||
    user.id ||
    null;
  if (!raw) return '';
  try {
    return String(normalizeBusinessStorageId(raw) || raw);
  } catch {
    return String(raw);
  }
}

/** @deprecated Prefer resolveSessionKeyFromUser — same logic, clearer name for login. */
export function resolveLoginBusinessId(user) {
  return resolveSessionKeyFromUser(user);
}

/**
 * @returns {string} canonical business id or ''
 */
export function resolveAuthSessionKeyFromStorage() {
  try {
    return resolveSessionKeyFromUser(readStoredSessionUser());
  } catch {
    return '';
  }
}
